import React from 'react';

class Modal extends React.Component {

    getRentTable() {
        return <table>
            <thead>
                <tr><th className="category-name" colSpan="6">Nuevas tarifas de renta a los salarios</th></tr>
                <tr>
                    <th>De</th>
                    <th>Hasta</th>
                    <th>Porcentaje</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>&cent;0</td>
                    <td>&cent;817000</td>
                    <td>0%</td>
                </tr>
                <tr>
                    <td>&cent;817000</td>
                    <td>&cent;1199000</td>
                    <td>10%</td>
                </tr>
                <tr>
                    <td>&cent;1199000</td>
                    <td>&cent;2103000</td>
                    <td>15%</td>
                </tr>
                <tr>
                    <td>&cent;2103000</td>
                    <td>&cent;4205000</td>
                    <td>20%</td>
                </tr>
                <tr>
                    <td>&cent;4205000</td>
                    <td></td>
                    <td>25%</td>
                </tr>
            </tbody>
        </table>
    }

    render() {
        var content = !this.props.rent ? <p>{this.props.content}</p> : this.getRentTable();
        return <div class="modal-content">
                    <div class="modal-header">
                        <button onClick={ this.props.close } type="button" class="close" data-dismiss="modal">×</button>
                        <h1>{this.props.title}</h1>
                    </div>
                    <div class="modal-body">
                        <div class="content">
                            <div class="bd-example">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>;
    }

}

export default Modal;